exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1wgr2{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1wgr2:hover{opacity:.7}.b_gEH{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._3OUJX{font-size:16px;line-height:17px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}div[data-hook=player-container][max-width~=\"550px\"] ._3OUJX{font-size:14px;line-height:15px}div[data-hook=player-container][max-width~=\"300px\"] ._3OUJX{font-size:12px;line-height:13px}div[data-hook=player-container][data-in-full-screen=true] ._3OUJX{font-size:20px;line-height:20px}._3OUJX.tow0a{cursor:pointer}", ""]);

// exports
exports.locals = {
	"controlButton": "_1wgr2",
	"hidden": "b_gEH",
	"title": "_3OUJX",
	"link": "tow0a"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--10-1!../node_modules/postcss-loader/lib??ref--10-2!../node_modules/sass-loader/lib/loader.js??ref--10-3!../node_modules/playable/dist/src/modules/ui/title/title.scss
// module id = 145
// module chunks = 0